import React from 'react'

import { Container } from './styles'

const Copyright = () => (
  <Container>
    2021 &copy; Galo Monitor
  </Container>
)

export default Copyright
